import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { ISessionUser, IErroLogin } from 'shared/types';

const { persistAtom } = recoilPersist();

export const sessionUser = atom<ISessionUser | null>({
  key: 'sessionUser',
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const erroLogin = atom<IErroLogin | null>({
  key: 'erroLogin',
  default: null,
});